import { render, staticRenderFns } from "./AssetsList.vue?vue&type=template&id=aab6f304&scoped=true&"
import script from "./AssetsList.vue?vue&type=script&lang=js&"
export * from "./AssetsList.vue?vue&type=script&lang=js&"
import style0 from "./AssetsList.vue?vue&type=style&index=0&id=aab6f304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab6f304",
  null
  
)

export default component.exports